import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  RoomOutput2,
  TeamOutput,
  UserOutput,
} from "~@/graphql/codegen/generated";

export type ChatsAssignee = TeamOutput | UserOutput | undefined;

type ChatsAssigningState = {
  selectedAssignee: ChatsAssignee | undefined;
  selectedChatRooms: RoomOutput2[];
};

const initialState: ChatsAssigningState = {
  selectedAssignee: undefined,
  selectedChatRooms: [],
};

const chatsAssigningSlice = createSlice({
  name: "chatsAssigning",
  initialState,
  reducers: {
    setSelectedAssignee(
      state,
      action: PayloadAction<ChatsAssignee | undefined>
    ) {
      state.selectedAssignee = action.payload;
    },
    setSelectedChatRooms(state, action: PayloadAction<RoomOutput2[]>) {
      state.selectedChatRooms = action.payload;
    },
    clearSelectedChatRooms(state) {
      state.selectedChatRooms = [];
    },
    clearSelectedAssignee(state) {
      state.selectedAssignee = undefined;
    },
    resetChatsAssigning(state) {
      state.selectedAssignee = undefined;
      state.selectedChatRooms = [];
    },
  },
});

export const {
  setSelectedAssignee,
  setSelectedChatRooms,
  clearSelectedChatRooms,
  clearSelectedAssignee,
  resetChatsAssigning,
} = chatsAssigningSlice.actions;

export default chatsAssigningSlice.reducer;
